import { Component, computed, effect, inject, input, model, output, untracked } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FORM_FIELD } from '@angular/forms/signals';

import { of } from 'rxjs';

import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../directives/spinner-loader.directive';
import { DeviceModelItem } from '../../../models/asset';

@Component({
  selector: 'fs-model-select',
  imports: [SpinnerLoaderDirective],
  templateUrl: './model-select.html',
  styleUrl: './model-select.scss',
})
export class ModelSelect {
  private readonly assetService = inject(AssetService);
  protected readonly formField = inject(FORM_FIELD, { optional: true });
  
  readonly value = model<DeviceModelItem | null>(null);
  readonly touch = output<void>();
  readonly disabled = input<boolean>(false);
  readonly assetVendorId = input<string>('');
  readonly vendorId = input<string>('');
  readonly errors = computed(() => this.formField?.errors() ?? []);
  readonly isInvalid = computed(() => !!this.formField?.state().invalid() && !!this.formField?.state().touched());

  constructor() {
    effect(() => {
      this.assetVendorId();
      
      untracked(() => {
        this.value.set(null);
      })
    });
  }

  protected readonly modelResource = rxResource({
    params: () => ({
      assetVendorId: this.assetVendorId()
    }),
    stream: ({ params }) => {
      if (!this.disabled()) return this.assetService.getDeviceModels(params);
      return of([])
    }
  });

  onBlur() {
    this.touch.emit();
  }

  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const model = this.modelResource.value()?.find((item) => String(item.id) === target.value) ?? null;
    this.value.set(model);
    this.touch.emit();
  }
}
